import { render, staticRenderFns } from "./ClusterProviderIcon.vue?vue&type=template&id=2c25acf0&scoped=true&"
import script from "./ClusterProviderIcon.vue?vue&type=script&lang=js&"
export * from "./ClusterProviderIcon.vue?vue&type=script&lang=js&"
import style0 from "./ClusterProviderIcon.vue?vue&type=style&index=0&id=2c25acf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c25acf0",
  null
  
)

export default component.exports